import { EntityConfig } from '../hooks/useEntity';

export interface AppIntegration {
  id: string;
  userId: string;
  appId: string;
  appName: string;
  connected: boolean;
  connectionData?: any;
  lastSynced?: string;
  createdAt: string;
  updatedAt: string;
}

export const appIntegrationEntityConfig: EntityConfig<AppIntegration> = {
  entityType: 'AppIntegration',
  properties: {
    userId: { type: 'string', required: true },
    appId: { type: 'string', required: true },
    appName: { type: 'string', required: true },
    connected: { type: 'boolean', required: true },
    connectionData: { type: 'json', required: false },
    lastSynced: { type: 'string', required: false },
    createdAt: { type: 'string', required: false },
    updatedAt: { type: 'string', required: false },
  },
  orderBy: { field: 'appName', direction: 'asc' },
};
